document.addEventListener("DOMContentLoaded", function () {
  var COLUMNS_KEY = "cinfer_columns";
  var PER_PAGE_KEY = "cinfer_per_page";

  /* ==================== COLUNAS ==================== */
  function getProductGrid() {
    return document.getElementById("product-grid");
  }

  function setActiveColumnButton(columns) {
    document.querySelectorAll(".view-toggle-buttons button").forEach(function (b) {
      b.classList.toggle("active", b.dataset.columns === String(columns));
    });
    // Dropdown "Produtos p/ linha" (coleção)
    document.querySelectorAll('[data-role="columns-select"]').forEach(function (s) {
      s.value = String(columns);
    });
  }

  function applyColumns(columns) {
    var grid = getProductGrid();
    if (!grid) return;
    [2, 4, 6].forEach(function (n) {
      grid.classList.remove("grid--" + n + "-col-desktop");
    });
    grid.classList.add("grid--" + columns + "-col-desktop");
    grid.dataset.currentColumns = columns;
  }

  function applyStoredColumns() {
    var stored = sessionStorage.getItem(COLUMNS_KEY);
    var grid = getProductGrid();
    if (stored && grid && grid.dataset.currentColumns !== stored) {
      applyColumns(stored);
      setActiveColumnButton(stored);
    }
  }

  applyStoredColumns();

  // Clique nos botões de colunas (delegação — funciona mesmo depois de trocas AJAX do grid)
  document.addEventListener("click", function (e) {
    var button = e.target.closest(".view-toggle-buttons button");
    if (!button) return;
    var selectedColumns = button.dataset.columns;
    applyColumns(selectedColumns);
    setActiveColumnButton(selectedColumns);
    sessionStorage.setItem(COLUMNS_KEY, selectedColumns);
  });

  // Dropdown "Produtos p/ linha" (coleção) — mesma lógica dos botões
  document.addEventListener("change", function (e) {
    var select = e.target.closest('[data-role="columns-select"]');
    if (!select) return;
    applyColumns(select.value);
    setActiveColumnButton(select.value);
    sessionStorage.setItem(COLUMNS_KEY, select.value);
  });

  /* ==================== PRODUTOS POR PÁGINA + PAGINAÇÃO (via AJAX, sem reload) ==================== */

  function showLoading() {
    var overlay = document.querySelector(".loading-overlay");
    if (overlay) overlay.classList.add("active");
  }

  function hideLoading() {
    var overlay = document.querySelector(".loading-overlay");
    if (overlay) overlay.classList.remove("active");
  }

  function getViewParam(url) {
    try {
      return new URL(url, window.location.origin).searchParams.get("view") || "";
    } catch (e) {
      return "";
    }
  }

  // Busca o novo HTML e troca só as partes necessárias, sem recarregar a página
  // scrollToTop: só faz scroll quando a troca foi pedida pelo utilizador (select ou paginação),
  // nunca na reconciliação automática ao entrar numa página nova.
  function loadContent(url, scrollToTop) {
    showLoading();

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");

        // Grid de produtos (populado ou mensagem vazia — ambos usam #product-grid)
        var newGrid = doc.getElementById("product-grid");
        var currentGrid = document.getElementById("product-grid");
        if (newGrid && currentGrid) {
          currentGrid.outerHTML = newGrid.outerHTML;
        }

        // Contador de produtos
        var newCount = doc.getElementById("custom-product-count");
        var currentCount = document.getElementById("custom-product-count");
        if (newCount && currentCount) {
          currentCount.outerHTML = newCount.outerHTML;
        }

        // Select "Produtos por página" — trocado para refletir o valor real aplicado
        var newSelect = doc.querySelector('[data-role="per-page-select"]');
        var currentSelect = document.querySelector('[data-role="per-page-select"]');
        if (newSelect && currentSelect) {
          currentSelect.outerHTML = newSelect.outerHTML;
        }

        // Paginação (pode desaparecer ou aparecer consoante o nº de páginas)
        var newPagination = doc.querySelector(".pagination-wrapper");
        var currentPagination = document.querySelector(".pagination-wrapper");
        if (currentPagination) currentPagination.remove();
        if (newPagination) {
          var grid = document.getElementById("product-grid");
          if (grid) grid.insertAdjacentElement("afterend", newPagination);
        }

        // URL visível, sem reload (partilhável, botão "recuar" funciona)
        history.pushState({}, "", url);

        window.currentPerPageView = getViewParam(url);
        applyStoredColumns();

        hideLoading();

        if (scrollToTop) {
          var container = document.getElementById("ProductGridContainer");
          if (container) container.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      })
      .catch(function (error) {
        console.error("Erro ao carregar conteúdo:", error);
        hideLoading();
      });
  }

  window.__gridLoadContent = loadContent;

  // Clique nos links de paginação (delegação — cobre também a paginação vinda de trocas AJAX)
  document.addEventListener("click", function (e) {
    var link = e.target.closest(".pagination-wrapper .pagination__item[href]");
    if (!link) return;
    e.preventDefault();
    loadContent(link.getAttribute("href"), true);
  });

  // Reconciliação ao entrar na página: se há preferência guardada diferente da atual,
  // carrega-a via AJAX SEM fazer scroll (o utilizador acabou de chegar, já está no topo)
  var storedPerPage = sessionStorage.getItem(PER_PAGE_KEY);
  var currentView = window.currentPerPageView || "";
  if (storedPerPage !== null && storedPerPage !== currentView) {
    var params = new URLSearchParams(window.location.search);
    if (storedPerPage) {
      params.set("view", storedPerPage);
    } else {
      params.delete("view");
    }
    params.delete("page");
    loadContent(window.location.pathname + "?" + params.toString(), false);
  }
});

/* Chamada pelo <select> "Produtos por página" em ambos os ficheiros */
function applyPerPage(value) {
  sessionStorage.setItem("cinfer_per_page", value);
  var params = new URLSearchParams(window.location.search);
  if (value) {
    params.set("view", value);
  } else {
    params.delete("view");
  }
  params.delete("page");
  window.__gridLoadContent(window.location.pathname + "?" + params.toString(), true);
}